import { request } from './client';

/**
 * Downloads an attachment file using the LEAD customer-facing endpoint
 * @param attachmentId - The ID of the attachment to download
 * @returns Promise that resolves to the file blob
 */
export function downloadAttachment(attachmentId: string | number): Promise<Blob> {
  return request('GET', `/v1/account/attachments/${attachmentId}/contents`);
}
